import { SnackbarProvider } from 'notistack';

const NoticeProvider = ({ children }: { children: React.ReactNode }) => (
    <SnackbarProvider
        // action={snackbarKey => <SnackbarCloseButton snackbarKey={snackbarKey} />}
        maxSnack={5}
        anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
        // Components={{
        //     success: StyledMaterialDesignContent,
        //     error: StyledMaterialDesignContent,
        //     warning: StyledMaterialDesignContent,
        //     info: StyledMaterialDesignContent,
        //     default: StyledMaterialDesignContent,
        // }}
    >
        {children}
    </SnackbarProvider>
);

export default NoticeProvider;
